// extracted by mini-css-extract-plugin
module.exports = {"modal":"Dialog_modal__nI2ID","icon":"Dialog_icon__3EkXT","title":"Dialog_title__2JtZ4","text":"Dialog_text__34W9t","buttonContainer":"Dialog_buttonContainer__3GDRs"};